import React, { useState } from 'react';
import styled from '@emotion/styled';
import Image from 'next/image';
import SignupAgreement from '@src/components/User/Signup/SignupAgreement';

const text = {
  title: '이용약관동의 ',
  agreeAll: '필수 약관 및 마케팅 활용(선택)에 모두 동의합니다.',
  popup: '보기',
};

const checklist = {
  ageConfirmation: '[필수] 귀하는 만 14세 이상입니까?',
  legelengineTnC: '[필수] 리걸엔진 통합 이용약관',
  privacyPolicy: '[필수] 개인정보 처리방침',
  mktAgreement: '[선택] 마케팅 활용 동의',
};

export const CheckboxComponent = (props) => {
  const { values, handleCheckbox, handleSignUpAgreeAll } = props;

  // pop up
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handlePopupClick = (e) => {
    e.preventDefault();
    const { name } = e.target;
    setIsPopupOpen({ ...isPopupOpen, [name]: !isPopupOpen[name] });
  };

  const checkboxContents = () => {
    return (
      <>
        {Object.entries(checklist).map((ele) => {
          return (
            <CheckboxWarp key={ele[0]}>
              <CheckboxTitle />
              <CheckboxLabel>
                <CheckboxInput name={ele[0]} type='checkbox' onChange={handleCheckbox} checked={values[ele[0]]} />
                <CheckboxText>
                  {ele[1]}
                  <AgreementPopupButton name={ele[0]} onClick={handlePopupClick}>
                    {text.popup}
                  </AgreementPopupButton>
                  {isPopupOpen[ele[0]] && <SignupAgreement name={ele[0]} onClick={handlePopupClick} />}
                </CheckboxText>
              </CheckboxLabel>
            </CheckboxWarp>
          );
        })}
      </>
    );
  };

  return (
    <CheckboxContainer>
      <MobileCheckboxTitle>
        {text.title}
        <Image src='/red_dot.png' alt='red_dot' width={5} height={5} />
      </MobileCheckboxTitle>
      <CheckboxWarp>
        <CheckboxTitle>
          {text.title}
          <Image src='/red_dot.png' alt='red_dot' width={5} height={5} />
        </CheckboxTitle>
        <CheckboxLabel>
          <CheckboxInput name='agreeAll' type='checkbox' onChange={handleSignUpAgreeAll} />
          <CheckboxAllAgreeText>{text.agreeAll}</CheckboxAllAgreeText>
        </CheckboxLabel>
      </CheckboxWarp>
      {checkboxContents()}
    </CheckboxContainer>
  );
};

const CheckboxContainer = styled.article`
  margin: 50px 0;
`;

const CheckboxWarp = styled.div`
  display: flex;
  flex-direction: row;
  @media only screen and (max-width: 992px) {
    margin-top: 10px;
  }
`;

const MobileCheckboxTitle = styled.div`
  display: none;
  @media only screen and (max-width: 992px) {
    display: block;
    margin-top: 46px;
    margin-bottom: 20px;
  }
`;

const CheckboxTitle = styled.div`
  width: 20%;
  @media only screen and (max-width: 992px) {
    display: none;
  }
`;

const CheckboxLabel = styled.label`
  display: flex;
  cursor: pointer;
`;

const CheckboxInput = styled.input`
  margin-top: 0.5rem;
  cursor: pointer;
`;

const CheckboxAllAgreeText = styled.div`
  margin-left: 10px;
  font-weight: 700;
  font-size: 18px;
  @media only screen and (max-width: 992px) {
    font-size: 16px;
  }
`;

const CheckboxText = styled.div`
  margin-left: 10px;
  @media only screen and (max-width: 992px) {
    font-size: 14px;
  }
`;

const AgreementPopupButton = styled.button`
  display: inline;
  color: #555;
  text-decoration: underline;
  background-color: Transparent;
  background-repeat: no-repeat;
  border: none;
  overflow: hidden;
  outline: none;
  :focus {
    outline: none;
  }
`;
